export default {
  header: {
    app: 'AJINGA APP',
    candidate: 'Job Seekers',
    employer: 'Recruiting Solutions',
    intelligence: 'AJINGA Intelligence',
    login: 'Login',
    hotline: {
      cnUser: 'China users',
      allUser: 'All users'
    },
    userMenu: {
      searchJob: 'Search Jobs',
      myHomePage: 'My Home Page',
      recruitingManagement: 'Recruiting Management',
      home: 'Ajinga Home Page',
      companyJobList: 'Recruiting Management',
      crmManagement: 'CRM Management',
      editCompanyProfile: 'Change Company Profile',
      editCompanyCulture: 'Change Company Culture',
      changePassword: 'Change Password',
      systemNotification: 'System Notification',
      logout: 'Sign Out'
    }
  },
  footer: {
    home: 'Home',
    aboutUs: 'About us',
    contactUs: 'Contact us',
    privacyPolicy: 'Service Terms and Privacy Policy'
  },
  newLayout: {
    menu: {
      hrDashboard: 'Dashboard',
      applicantList: 'Candidates',
      applicantProfile: 'Personal Information',
      jobList: 'Jobs',
      talentPool: 'Talent Pool',
      crm: 'CRM',
      referral: 'Referral',
      interview: 'Interview',
      charReport: 'Data',
      companyAdmin: 'Admin',
      rpa: 'RPA',
      apScheduler: 'Scheduler Tasks',
      clientAdmin: 'Clients',
      chatBot: 'ChatBot',
      hrReport: 'Data',
      potentialList: 'Potential',
      potentialProfile: 'Potential Information',
      AgencyApplicationList: 'Agency Application List',
      AgencyApplicationProfile: 'Agency Application Profile'
    },
    candidateMenu: {
      applications: 'My Applications',
      assessment: 'Assessment',
      myReport: 'My Report',
      profile: 'My Profile',
      referral: 'Rewards',
      policy: 'My Consent',
      aboutReferral: 'About Referral',
      changeEmail: 'Change Email',
      bindMobile: 'Mobile Connect'
    }
  }
}
